import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class CarouselSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: 5000,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: true,
            cellSelector: '.carousel__slide',
            cellAlign: 'center',
            fade: true,
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.carousel__slide');
        this.slidesCount = this.$slides.length;

        this.$controls = $('.carousel__controls-button');

        if (this.slidesCount > 0) {
            this._createSlider();
            this._bindEvents();
            this._updateDarkMode(0); // état initial
            this._setEqualHeight();
        }
    }

	_createSlider() {
        this.flkty = new Flickity(this.$el[0], this.options);
    }

    _bindEvents() {

        // clic sur les boutons
        this.$controls.on('click', (e) => {
            const index = $(e.currentTarget).index();
            this.flkty.select(index);
        });

        // changement de slide
        this.flkty.on('change', (index) => {
            // Puces de navigation
            this.$controls.removeClass('is-selected');
            this.$controls.eq(index).addClass('is-selected');
            // MAJ état dark
            this._updateDarkMode(index);
        });
    }

    _updateDarkMode(index) {
        const $currentSlide = this.$slides.eq(index);

        if ($currentSlide.hasClass('carousel__slide--darken')) {
            this.$el.addClass('carousel--dark');
        } else {
            this.$el.removeClass('carousel--dark');
        }
    }

    _setEqualHeight() {
        let maxHeight = 0;
        this.$slides = this.$el.find('.carousel__slide');

        this.$slides.css('height', 'auto');

        this.$slides.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });

        this.$slides.height(maxHeight);
    }
}

export default CarouselSlider;
